var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelperDoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 1.55556V8.55556H8.55556V12.4444H1.55556V1.55556H12.4444ZM12.4444 0H1.55556C0.7 0 0 0.7 0 1.55556V12.4444C0 13.3 0.7 14 1.55556 14H9.33333L14 9.33333V1.55556C14 0.7 13.3 0 12.4444 0ZM7 8.55556H3.11111V7H7V8.55556ZM10.8889 5.44444H3.11111V3.88889H10.8889V5.44444Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelperDoc);
export default __webpack_public_path__ + "static/media/helper-doc.a0628b1d825bc9cd82f2c317eb3d8e6c.svg";
export { ForwardRef as ReactComponent };